import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { useGlobalContext } from 'context/GlobalContext';
import { KEYS } from 'helpers/react-query.config';

import { TicketDetail } from '../../../../../../api/ticket';

function useGetTicketDetail(
  ticketId: number,
  handleSuccess: (data: TicketDetail) => void
) {
  const { showApiError } = useGlobalContext();
  const { ticket: ticketApi } = useApiContext();
  const { t } = useTranslation('global');

  const getTicketDetail = useQuery(
    KEYS.ticket.tickets.detail(Number(ticketId)),
    () => ticketApi.tickets.detail(Number(ticketId)),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      enabled: !!ticketId,
      onError: (error) => showApiError(error, t('errorMessages.ticketDetails')),
      onSuccess: (data) => {
        handleSuccess(data);
      }
    }
  );

  return getTicketDetail;
}

export default useGetTicketDetail;
